import { styled } from "@mui/material";
import Divider from "../../Divider";
import Button from "../../Button";

export const StyledButtonsWrapper = styled("div")`
  padding: 0 ${({ theme }) => theme.wsc.spacing[2]};
`;

export const StyledDivider = styled(Divider)`
  && {
    margin: ${({ theme }) => theme.wsc.spacing[1]} 0;
  }
`;

export const StyledButtonsContainer = styled("div")`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.wsc.spacing[1]};
`;

export const StyledButton = styled(Button)`
  && {
    min-width: auto;
  }
`;
